import React, { useEffect, useState } from "react";
import { Layout, Space, Table, PageHeader, Select, Button, message, Avatar, Row, Col, Tabs, Divider, Input } from "antd";
import { useHistory, useRouteMatch, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { DeleteOutlined } from "@ant-design/icons";




const SectionList = ({sectionItems=[],i,sectionData,sectionId,updateSection,selectedSectionId,freeTables, deleteCell}) => {

    const [section, setSections] = useState([])
    const [inlineDrag, setInlineDrag] = useState(false)

    useEffect(() => {
        setSections(sectionItems)

    }, [sectionItems])

   const handleDrag =(event)=>{
        event.preventDefault();
    }
    const randomIntFromInterval=(min, max) =>{ // min and max included 
      return Math.floor(Math.random() * (max - min + 1) + min)
    }
   const handleDrop = (event)=>{
        event.preventDefault();
       
        const itemData =JSON.parse( event.dataTransfer.getData('text/plain'));
        
        const tableName = freeTables.map(value =>
          value?.sectionsMap?.map(child => ({ ...child }))
        ).flat();
        const tableNameLength = tableName.map(value =>
          value?.sections?.map(child => ({ ...child }))
        ).flat()
        const newItem = {id: itemData.id, text: itemData.occupancy,color: itemData.color,
            paddingRight:itemData.paddingRight,table_number: itemData?.table_number ?? tableNameLength?.length+1}
        setSections([...section,newItem])
        updateSection(sectionId,[...section,newItem],selectedSectionId)
        if(inlineDrag)
          setInlineDrag(false)

    }
   const lastColSpan = sectionData.length % 2 ===1 ?24 :12;

   const handleDragCell = (event,item) => {
    setInlineDrag(true)
    event.dataTransfer.setData("text/plain", JSON.stringify(item));
    deleteCell(item)
  };

    return (
        <Col
        span={i === sectionData.length -1 ? lastColSpan : 12} key={i}
        className="table-section"
        style={{
          fontWeight: 400,
          fontSize: "20px",
          backgroundColor: ["#FFE4E4", "#DBFFFB", "#FFFAD2", "#F4E2FF"][
            i % 4
          ],
          color: ["#E12552", "#2543E1", "#E16925", "#E12596"][i % 4],
        }}
        // onDragOver={(e) => e.preventDefault()}
        // onDrop={() => sectionDrop(i)}
      >
        Section {i+1}
        <Row
        style={{
          margin: "1rem",
          marginLeft: 0,
          lineHeight: "2rem",
          textAlign: "center",
          fontSize: "15px",
          minHeight:"100px"
        }}
        onDrop={handleDrop}
        onDragOver={handleDrag}
      >
        {section.map((item, j) => (
          item &&
          <Col
          
          draggable
          onDragStart={(event)=>handleDragCell(event,item)}
            className="table-type"
            style={{ marginLeft: ".5rem", marginBottom: ".5rem",border:`1px solid ${item.color}`,
                 paddingRight: `${item.paddingRight}`  }}
          >
            <DeleteOutlined className="ml-1 delete-table-cell" onClick={()=>deleteCell(item)}/>
            <Input className="section-input"
            value={item.table_number}
            >
            </Input>
             
          </Col>
        ))}
      </Row>
      </Col>
    );
};

export default SectionList;
